module.exports = __webpack_public_path__ + "img/Innovazioni Griglia 3.a664fb60.webp";